(window.wonderwp || window).needGooglemap(function() {
    (function($, namespace) {
        function Popin(opt_options) {
            // Initialization
            this.setValues(opt_options);

            // popin specific
            this.div_ = document.createElement('div');
            this.div_.style.cssText = 'position: absolute; display:none; height:auto; background:white';
            this.div_.className = 'map-infobox';

            this.divWrap = document.createElement('div');
            this.divWrap.className = 'map-infobox-content';

            this.divInfoWrap = document.createElement('div');
            this.divInfoWrap.className = 'item-info';

            this.divTitle = document.createElement('div');
            this.divTitle.className = 'item-titre';

            this.divImg = document.createElement('div');
            this.divImg.className = 'item-image';

            this.divDesc = document.createElement('div');
            this.divDesc.className = 'item-desc';


            this.aLien = document.createElement('a');
            this.aLien.innerHTML = '';
            this.aLien.target = '_blank';
            this.aLien.className = 'map-layer-link';

            this.parts = [
                ['title', 'divTitle'],
                ['img', 'divImg'],
                ['desc', 'divDesc'],
                ['link', 'aLien']
            ];

            this.aClose = document.createElement('a');
            this.aClose.href="#";
            var scope = this;
            $(this.aClose).on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                scope.hide();
            });
            this.aClose.innerHTML = '&times;';
            this.aClose.className = 'close';

            this.divWrap.appendChild(this.aClose);
            this.divWrap.appendChild(this.divImg);
            this.divInfoWrap.appendChild(this.divTitle);
            this.divInfoWrap.appendChild(this.aLien);
            this.divInfoWrap.appendChild(this.divDesc);
            this.divWrap.appendChild(this.divInfoWrap);
            this.div_.appendChild(this.divWrap);
            this.$div = $(this.div_);
            this.position = null;
        };

        Popin.prototype = new google.maps.OverlayView;

    // Implement onAdd
        Popin.prototype.onAdd = function() {
            var pane = this.getPanes().floatPane;
            pane.appendChild(this.div_);
            this.div_.style.visibility = "visible";
        };

        Popin.prototype.setContent = function(position, data) {
            this.position = position;
            if(data) {
                if(typeof data === 'string') {
                    while(i--) this[this.parts[i][1]].style.display = 'none';
                    this.divDesc.innerHTML = data;
                    this.divDesc.style.display='block';
                    var i = this.parts.length;
                    this.divWrap.className+=' fromString';
                } else {
                    var i = this.parts.length,
                        e = null,
                        str = null;
                    while(i--) {
                        e = this[this.parts[i][1]];
                        str = data[this.parts[i][0]];
                        if(str && str.length) {
                            e.innerHTML = str;
                            e.style.display = 'block';
                        } else {
                            e.innerHTML = '';
                            e.style.display = 'none';
                        }
                    }
                    this.divWrap.className+=' fromObject';
                }
            }

        };

        Popin.prototype.hide = function() {
            if (this.div_) {
                this.div_.style.visibility = "hidden";
            }
            $('body').removeClass('has-popin');
        };

        Popin.prototype.close = function(that) {
            that = that || this;
            this.hide();
        };
        Popin.prototype.show = function() {
            if (this.div_) {
                this.div_.style.visibility = "visible";
            }
            $('body').addClass('has-popin');
        };

        Popin.prototype.toggle = function() {
            if (this.div_)
                this.div_.style.visibility === 'hidden' ? this.show() : this.hide();
        };

        Popin.prototype.setVisible = function(visible) {
            this[visible ? 'show' : 'hide']();
        };

    // Implement onRemove
        Popin.prototype.onRemove = function() {
            this.div_.parentNode.removeChild(this.div_);
        };

    // Implement draw
        Popin.prototype.draw = function() {
            if(this.getProjection()) {
                var position = this.getProjection().fromLatLngToDivPixel(this.position);


                this.div_.style.left = (position.x - this.$div.outerWidth() / 2) + 'px';
                this.div_.style.bottom = -(position.y-50)+ 'px';
                this.div_.style.display = 'block';
            }
        };

        namespace.Popin = Popin;
    })(jQuery, window.wonderwp || window);
});



// WEBPACK FOOTER //
// ./web/app/plugins/wwp-map/public/js/Gmap/GmapPopin.js